import { IS_GE_CHECKOUT, IS_PORTAL, jewlr_t, reverse_t } from "./application"
import getSpecialPaths from "./special-paths"

export const getHreflangs = (path) => {
  let defaultHref = ""
  const specialPaths = getSpecialPaths[path]
  let result = Object.entries(sl.config.site_url_by_country || {})
    .filter(([country]) => !specialPaths || specialPaths.includes(country))
    .map(([country, url]) => {
      const locale = (sl.locales || {})[country.toLowerCase()]
      const localizedPath = reverse_t(path, locale)
      const href = `${url}${localizedPath}`

      if (country === "US") {
        defaultHref = href
      }

      return {
        href,
        hreflang: locale,
      }
    })

  if (defaultHref) {
    result.push({
      href: defaultHref,
      hreflang: "x-default",
    })
  }

  return result
}

export const getMetaDescription = () =>
  `${IS_PORTAL() ? "Customize Your Jewelry" : "Jewlr"} ${jewlr_t(
    "terms.specialize"
  )}s in selling high quality ${jewlr_t("terms.personalized")} ${jewlr_t(
    "terms.jewelry"
  )}, made just for you. Create the perfect gift or ${jewlr_t(
    "terms.personalize"
  )} something for yourself. Enjoy Free ${jewlr_t(
    "terms.Shipping"
  )} and ${IS_GE_CHECKOUT() ? "30" : "99"}-Day Returns!`

export const getMetaKeywords = () =>
  `fine ${jewlr_t("terms.jewelry")}, ${jewlr_t("terms.jewelry")} ${jewlr_t(
    "terms.jewelry"
  )}, mothers rings, mothers ring, mother's ring, mother's rings, birthstone ${jewlr_t(
    "terms.jewelry"
  )} mothers birthstone ${jewlr_t("terms.jewelry")}, family ${jewlr_t(
    "terms.jewelry"
  )}`

export const getMetaIcons = () =>
  IS_PORTAL()
    ? {
        appleIcon: "cyj/apple-touch-icon.png",
        favicon: "cyj/favicon.ico",
        ogImage: "cyj/cyj-logo.jpg",
        png: "cyj/favicon-96x96.png",
        svg: "cyj/favicon.svg",
      }
    : {
        appleIcon: "jewlr/apple-touch-icon.png",
        favicon: "jewlr/favicon.ico",
        ogImage: "jewlr/jewlr-logo.jpg",
        png: "jewlr/favicon-96x96.png",
        svg: "jewlr/favicon.svg",
      }
